import { render } from "./DebtList.vue?vue&type=template&id=1c46c1d8"
import script from "./DebtList.vue?vue&type=script&lang=js"
export * from "./DebtList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__